"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemedyRelocatedIndicator = exports.APPLIED_RELOCATED_LABEL = void 0;
var _react = _interopRequireDefault(require("react"));
var _lucideReact = require("lucide-react");
var _hoverTooltip = require("@common/components/hover-tooltip");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var APPLIED_RELOCATED_LABEL = exports.APPLIED_RELOCATED_LABEL = "Applied, relocated";
var RemedyRelocatedIndicator = exports.RemedyRelocatedIndicator = function RemedyRelocatedIndicator(_ref) {
  var relocationSentence = _ref.relocationSentence;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-1 text-[11px] text-[#B45309] font-medium",
    "data-sentry-component": "RemedyRelocatedIndicator",
    "data-sentry-source-file": "RemedyRelocatedIndicator.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.Check, {
      size: 14,
      className: "text-[#B45309]",
      "data-sentry-element": "Check",
      "data-sentry-source-file": "RemedyRelocatedIndicator.tsx"
    }), APPLIED_RELOCATED_LABEL, /*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverTooltip.HoverTooltip, {
      content: relocationSentence,
      align: "start",
      "data-sentry-element": "HoverTooltip",
      "data-sentry-source-file": "RemedyRelocatedIndicator.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "inline-flex items-center cursor-help text-[#F59E0B] ml-0.5",
        "aria-label": relocationSentence,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.AlertTriangle, {
          size: 14,
          "data-sentry-element": "AlertTriangle",
          "data-sentry-source-file": "RemedyRelocatedIndicator.tsx"
        })
      })
    })]
  });
};